import { Grid2 } from '@mui/material';
import MetricCard from './MetricCard';
import { HeaderContent } from '../../types/reports';
import ReportBox from './ReportBox';

interface Props {
  totalSales: number;
  cashSales: number;
  creditSales: number;
  giftCardSales: number;
  isRefetching?: boolean;
  headerContent?: HeaderContent;
}

const GRID_ITEM_SIZE = {
  xs: 12,
  sm: 6,
  md: 3,
};

export default function RevenueReport({
  totalSales,
  cashSales,
  creditSales,
  giftCardSales,
  isRefetching,
  headerContent,
}: Props) {
  return (
    <ReportBox headerContent={headerContent} isLoading={isRefetching}>
      <Grid2 container spacing={2} width="100%">
        <Grid2 size={GRID_ITEM_SIZE} className="metric-card-grid">
          <MetricCard
            small
            metric={totalSales}
            name="Total Sales"
            type="dollar"
            isLoading={isRefetching}
          />
        </Grid2>
        <Grid2 size={GRID_ITEM_SIZE} className="metric-card-grid no-border">
          <MetricCard
            small
            metric={cashSales}
            name="Cash"
            type="dollar"
            isLoading={isRefetching}
          />
        </Grid2>
        <Grid2 size={GRID_ITEM_SIZE} className="metric-card-grid no-border">
          <MetricCard
            small
            metric={creditSales}
            name="Credit"
            type="dollar"
            isLoading={isRefetching}
          />
        </Grid2>
        <Grid2 size={GRID_ITEM_SIZE} className="metric-card-grid no-border">
          <MetricCard
            small
            metric={giftCardSales}
            name="Gift Card"
            type="dollar"
            isLoading={isRefetching}
          />
        </Grid2>
      </Grid2>
    </ReportBox>
  );
}
